<!--单位信息模块-->
<template>
  <span style="display: flex;margin-top: 8px;justify-content: space-between; ">
    <div class="topLeftTitleContent2 smallWindow">

      <div class="titled"> <img class="img" src="@/assets/kanban/11.png" />设备负荷
        <span class="iconed" @click="flagFned" style="cursor: pointer;">
          <img src="@/assets/kanban/Frame10.png" style="margin-right: 10px;" />
          <img src="@/assets/kanban/Union.png" />
        </span>
      </div>
      <div class="bodyBorder2" style=" align-items: center;">
        <div class="divbody">
          <div class="column">

            <canvasCircle class="circle" color="#86e4f5" backgroundColor="#395667" :pvalue="27973.2" pcontent="实时负荷(kW)"
              :rate="36.53"></canvasCircle>
          </div>
          <div class="column">

            <canvasCircle class="circle" color="#ff7656" backgroundColor="#395667" :pvalue="3091.6"
              pcontent="日最大负荷(kW)1" :rate="40.36"></canvasCircle>
          </div>
          <div class="column">

            <canvasCircle class="circle" color="#ff9900" backgroundColor="#395667" :pvalue="3091.6" pcontent="月最大负荷(kW)"
              :rate="40.36"></canvasCircle>
          </div>
        </div>

      </div>
      <div class="dialoged" v-if="flaged">
        <span class="dialoged_box">
          <span class="dialoged_tit">负荷设备信息</span>
          <div>
            <span>配电房数量: </span>
            <span class="p">0</span>
          </div>
          <div>
            <span>负荷设备数: </span>
            <span class="p">10</span>
          </div>
          <div>
            <span>日最大需量: </span>
            <span class="p">125068.6kW</span>
          </div>
          <div>
            <span>月最大需量: </span>
            <span class="p">34606.7kW</span>
          </div>
          <div>
            <span>负荷总容量: </span>
            <span class="p">76469kVA</span>
          </div>
        </span>
      </div>
    </div>
    <div class="topLeftTitleContent2 smallWindow" style=" width: calc(50% - 5px); margin-right: 3px; ">
      <div class="titled"> <img class="img" src="@/assets/kanban/11.png" />负荷分析
        <span class="iconed">
          <img src="@/assets/kanban/Union.png" />
        </span>
      </div>
      <div class="bodyBorder2">
        <div class="divbody" style=" height: 100%;padding-top: 0;">
          <vchart ref='vchartLine'></vchart>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
  import canvasCircle from '@/page/unitKanBan2/component/canvasCircle.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import {findDemand} from "../../../api/abbNewApi"

  export default {
    components: {
      canvasCircle,
      vchart,
    },
    data () {
      return {
        flaged: false,
        dayMaxNeed: 0,
        newdayMaxNeed: 0,
        monthMaxNeed: 0,
        newmonthMaxNeed: 0,
        dayMaxLoad: 0,
        monthMaxLoad: 0,
        todayLoadLine: [],
        nowLoadDeviceFromname: "",
        loadDeviceList: [],
        deviceNoToArchivesInfo: {},
        lineOption: {
          xAxis: {
            type: 'category',
          },
          yAxis: {
            type: 'value'
          },
          series: []
        },
      }
    },
    mounted () {
      var nv={
        xAxis: {
          type: 'category',
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#6f7284'
            }
          },
          axisLabel: {
            interval: 23,
            textStyle: {
              color: '#ffffff',
            }

          },
          data: this.xList,
        },
        yAxis: {
          type: 'value',
          name: '',
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#6f7284'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#ffffff',
            },
          },

        },
        legend: {
          data: ['昨日负荷','前日负荷','今日负荷'],
          x: 'right',
          y: 'top',
          padding: [10,40,0,0],
          orient: "horizontal",
          textStyle: {
            color: '#fft'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        backgroundColor: '',
        grid: {
          left: '3%',
          right: '3%',
          bottom: '8%',
          top: '14%',
          containLabel: true
        },
        series: [
          {
            data: [
              "26417.60",
              "26632.40",
              "26773.60",
              "27654.40",
              "28329.60",
              "28686.80",
              "29090.40",
              "29396.80",
              "29633.60",
              "29320.40",
              "29515.60",
              "29062.40",
              "29225.20",
              "29175.60",
              "29362.00",
              "29349.20",
              "29606.00",
              "29359.60",
              "29348.00",
              "29296.40",
              "29458.40",
              "29593.20",
              "29909.60",
              "29848.40",
              "29813.20",
              "29424.40",
              "29757.20",
              "29278.40",
              "29137.20",
              "29782.80",
              "29786.80",
              "29978.40",
              "30098.00",
              "30284.40",
              "30683.20",
              "30901.60",
              "30566.40",
              "30535.60",
              "30233.20",
              "30119.60",
              "30225.60",
              "29856.80",
              "29753.60",
              "29955.20",
              "30350.00",
              "30045.60",
              "30153.60",
              "30023.60",
              "30351.60",
              "30246.80",
              "30401.60",
              "30190.80",
              "30069.60",
              "29618.40",
              "29980.00",
              "30090.00",
              "30081.20",
              "30294.00",
              "29693.20",
              "30158.00",
              "29862.80",
              "30138.80",
              "29884.00",
              "29896.40",
              "29347.60",
              "29412.80",
              "28989.60",
              "29006.80",
              "28955.20",
              "28980.40",
              "29217.60",
              "29525.60",
              "29254.80",
              "29629.20",
              "29901.60",
              "29824.40",
              "30175.20",
              "30072.80",
              "30245.20",
              "30015.20",
              "29846.40",
              "29843.20",
              "30133.60",
              "29967.20",
              "30418.00",
              "4378.00",
              "28079.60",
              "28018.00",
              "27764.40",
              "26912.40",
              "26805.60",
              "26707.60",
              "26410.00",
              "26949.20",
              "27122.40",
              "27174.80",
              "26922.40",
              "27511.60",
              "27350.80",
              "27537.60",
              "27481.20",
              "27228.40",
              "28108.80",
              "28054.80",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            ],
            type: 'line',
            color: '#8515c1',
            areaStyle: {
              color: '#2e5897',
            },
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            name: '前日负荷'

          },
          {
            data: [
              "24525.60",
              "25387.20",
              "25355.60",
              "26419.60",
              "26900.40",
              "27298.80",
              "27354.40",
              "27681.20",
              "27541.20",
              "27410.40",
              "27606.40",
              "27572.40",
              "27352.40",
              "27306.40",
              "27859.60",
              "27783.60",
              "27933.60",
              "28010.00",
              "27993.20",
              "27814.00",
              "27870.00",
              "27892.80",
              "28377.20",
              "27690.40",
              "28150.40",
              "28216.80",
              "28016.40",
              "28680.40",
              "28790.80",
              "28920.00",
              "28508.00",
              "28706.00",
              "28652.80",
              "28990.80",
              "28855.20",
              "28313.20",
              "28259.20",
              "28112.40",
              "28534.40",
              "28556.40",
              "28624.00",
              "28567.60",
              "28869.60",
              "28890.40",
              "28750.40",
              "28588.40",
              "28890.40",
              "28786.40",
              "28570.40",
              "28932.40",
              "28756.40",
              "28828.40",
              "28632.40",
              "28474.00",
              "28600.00",
              "28676.00",
              "28378.00",
              "28582.00",
              "28340.00",
              "28598.00",
              "28322.00",
              "4684.00",
              "27832.00",
              "27920.00",
              "27838.00",
              "27918.00",
              "27818.00",
              "27778.00",
              "27952.00",
              "27614.00",
              "27936.00",
              "28064.00",
              "27984.00",
              "27966.00",
              "27824.00",
              "27978.00",
              "28584.00",
              "28191.20",
              "28349.20",
              "28321.20",
              "28269.20",
              "28619.20",
              "28427.20",
              "27905.20",
              "27674.80",
              "26528.00",
              "26714.40",
              "25520.00",
              "25596.40",
              "25521.20",
              "25776.00",
              "25438.00",
              "25646.00",
              "25558.80",
              "25552.40",
              "25222.40",
              "25085.60",
              "25420.80",
              "25338.80",
              "25500.80",
              "25400.80",
              "25698.40",
              "25982.00",
              "26490.00",
              "26486.00",
              "26372.00",
              "26572.00",
              "27063.60",
              "26791.20",
              "26325.20",
              "26471.20",
              "26755.20",
              "27151.20",
              "26707.20",
              "26856.40",
              "26660.40",
              "26412.40",
              "26817.60",
              "26645.60",
              "24564.40",
              "24879.20",
              "24546.00",
              "24877.20",
              "24599.60",
              "24866.00",
              "24428.00",
              "25089.20",
              "25253.60",
              "24577.60",
              null,
              "24676.80",
              "24780.40",
              "25058.00",
              "25109.60",
              "24800.80",
              "25674.00",
              "25431.20",
              "25548.00",
              "25587.20",
              "25187.20",
              "25054.40",
              "24862.00",
              "25168.40",
              "24780.00",
              "25203.20",
              "25528.40",
              "25960.00",
              "26153.60",
              "26594.00",
              "26721.60",
              "27048.40",
              "27137.60",
              "26777.60",
              null,
              "26849.60",
              "26600.40",
              "26653.20",
              "26905.60",
              "27150.80",
              "27206.40",
              "27224.80",
              "27232.00",
              "27071.60",
              "27229.60",
              "27465.20",
              "27813.20",
              "27472.80",
              "25518.80",
              "25748.80",
              "25955.20",
              "25816.00",
              "25923.60",
              "26404.00",
              "26334.80",
              "26274.00",
              "25940.00",
              "26029.20",
              "26375.20",
              "26211.20",
              "26425.20",
              "26255.60",
              "25935.60",
              "26664.00",
              "26620.40",
              "26398.40",
              "26130.00",
              "25943.20",
              "26244.00",
              "26163.20",
              "26234.40",
              "25783.20",
              "25852.80",
              "26507.20",
              "26800.80",
              "26520.80",
              "26395.20",
              "26463.60",
              "26629.20",
              "26409.20",
              "26482.40",
              "26411.20",
              "26608.00",
              "26469.20",
              "26159.60",
              "25705.20",
              "25567.20",
              "25828.80",
              "25472.00",
              "25384.80",
              "25484.40",
              "25085.20",
              "25190.80",
              "25502.00",
              "25179.20",
              "25330.00",
              "25664.00",
              "25276.40",
              "25507.60",
              "25837.20",
              "26247.20",
              "25876.00",
              "25837.60",
              "25815.20",
              "25611.20",
              "25537.60",
              "25100.00",
              "25534.00",
              "25178.00",
              "26012.40",
              "26390.00",
              "27050.00",
              "27208.80",
              "27174.00",
              "27353.60",
              "27673.60",
              "3966.00",
              "27510.40",
              "27342.00",
              "27124.80",
              "27164.40",
              "26739.60",
              "26975.60",
              "26992.80",
              "27227.60",
              "27507.20",
              "27111.20",
              "26964.40",
              "26902.40",
              "26870.40",
              "27094.80",
              "28072.40",
              "27236.80",
              "27165.20",
              "27328.00",
              "27266.80",
              "26900.40",
              "27029.60",
              "27270.40",
              "27178.40",
              "26997.60",
              "27294.40",
              "27181.60",
              "27051.20",
              "26950.80",
              "26696.00",
              "27186.00",
              "27173.60",
              "27000.80",
              "27063.60",
              "27021.60",
              "27666.80",
              "27348.00",
              "27147.20",
              "27203.20",
              "27024.40",
              "27140.40",
              "27150.40",
              "26851.20",
              "27038.40",
              "26315.60",
              "26616.00",
              "26581.60",
              "26546.00",
              "26382.40",
              "26470.80",
              "26360.40",
              "26374.40",
              "26147.60"
            ],
            type: 'line',
            color: '#ff9900',
            areaStyle: {
              color: '#2e5897',
            },
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            name: '昨日负荷'
          },
          {
            data: [
              "25476.00",
              "26349.60",
              "26009.60",
              "27134.00",
              "27941.20",
              "28118.40",
              "28606.80",
              "28536.80",
              "28690.80",
              "28566.80",
              "28561.60",
              "28306.00",
              "28630.00",
              "28538.00",
              "28476.40",
              "28382.40",
              "28764.40",
              "28870.40",
              "28898.40",
              "28562.40",
              "28938.40",
              "29074.40",
              "29178.80",
              "29416.00",
              "28982.00",
              "29306.00",
              "29272.00",
              "29250.00",
              "29122.00",
              "29192.00",
              "28936.00",
              "28916.00",
              "29244.00",
              "29005.20",
              "28779.20",
              "28787.20",
              "29459.20",
              "29115.20",
              "29423.20",
              "29477.20",
              "29133.20",
              "28767.20",
              "29101.20",
              "29183.20",
              "29021.20",
              "28955.60",
              "29115.60",
              "29771.60",
              "29297.60",
              "29215.60",
              "29449.60",
              "29465.60",
              "29179.20",
              "29399.20",
              "4876.00",
              "29299.20",
              "28941.20",
              "28663.20",
              "28497.20",
              "28620.00",
              "28802.00",
              "28690.00",
              "28325.60",
              "28569.60",
              "28191.60",
              "28557.60",
              "27864.00",
              "28194.00",
              "4202.00",
              "27450.80",
              "28006.80",
              "27961.60",
              "28326.80",
              "28580.00",
              "28756.00",
              "29106.40",
              "29112.40",
              "28891.60",
              "29127.20",
              "28689.20",
              "28923.20",
              "28763.20",
              "28828.40",
              "28660.80",
              "28672.80",
              "27107.60",
              "26534.00",
              "26577.20",
              "25535.20",
              "25555.20",
              "25542.00",
              "25593.20",
              "25971.20",
              "25885.20",
              "25695.20",
              "25882.80",
              "25733.60",
              "26066.80",
              "26242.80",
              "26315.60",
              "26456.00",
              "26746.00",
              "27042.00",
              "26784.00",
              "26667.60",
              "27230.00",
              "27578.00",
              "27196.40",
              "27116.80",
              "27232.80",
              "26699.60",
              "27257.60",
              "27250.00",
              "27588.00",
              "27733.60",
              "27431.60",
              "27849.60",
              "27509.20",
              "27779.20",
              "26358.80",
              "25732.40",
              "25380.40",
              "24969.20",
              "24955.60",
              "25027.60",
              "25232.00",
              "24963.60",
              "25230.80",
              "25132.40",
              "25297.60",
              "25346.40",
              "25322.80",
              "25440.40",
              "25228.80",
              "25350.80",
              "24964.40",
              "25139.20",
              "25108.00",
              "25362.00",
              "24947.20",
              "25317.60",
              "25157.60",
              "24723.20",
              "24591.60",
              "24669.60",
              "25395.20",
              "25632.80",
              "26044.40",
              "26323.60",
              "26146.80",
              "26632.40",
              "26336.40",
              "26562.00",
              "26592.40",
              "26393.20",
              "26542.40",
              "26842.80",
              "26462.00",
              "26850.40",
              "26980.40",
              "26948.40",
              "26865.20",
              "27039.60",
              "27215.60",
              "27765.60",
              "27186.40",
              "27468.40",
              "24614.80",
              "24621.20",
              "24766.40",
              "25460.00",
              "25443.60",
              "25511.60",
              "25378.00",
              "25130.00",
              "25004.00",
              "25063.20",
              "25143.60",
              "25147.60",
              "25124.00",
              "25071.60",
              "24622.80",
              "24914.80",
              "24950.40",
              "25495.20",
              "24816.00",
              "25216.40",
              "25114.00",
              "24903.60",
              "25157.60",
              "24808.80",
              "25114.80",
              "25080.40",
              "25390.40",
              "25322.00",
              "25347.20",
              "24774.40",
              "25144.80",
              "25114.40",
              "25066.40",
              "25084.80",
              "25118.00",
              "25397.60",
              "25246.80",
              "25025.60",
              "24857.20",
              "24255.60",
              "24391.20",
              "24180.40",
              "23959.20",
              "24170.80",
              "23882.40",
              "24205.20",
              "24268.00",
              "24088.80",
              "23892.40",
              "23858.80",
              "24379.60",
              "24109.20",
              "24142.00",
              "24374.40",
              "24422.80",
              "24188.80",
              "24037.20",
              "24417.20",
              "24437.60",
              "25366.40",
              "25253.60",
              "25981.20",
              "25523.20",
              "26262.80",
              "25719.60",
              "25847.20",
              "26255.20",
              "26020.80",
              "26004.40",
              "26176.40",
              "25799.60",
              "25975.20",
              "25536.80",
              "25272.80",
              "25464.40",
              "25496.40",
              "25288.40",
              "25364.40",
              "25708.80",
              "25322.80",
              "25038.80",
              "25061.60",
              "25109.60",
              "25683.60",
              "25725.20",
              "25560.40",
              "25704.40",
              "25906.40",
              "25382.40",
              "25307.60",
              "25375.20",
              "25527.20",
              "25229.20",
              "25397.20",
              "25435.20",
              "25031.20",
              "25304.00",
              "25412.00",
              "25220.00",
              "24793.60",
              "24907.20",
              "24738.00",
              "25112.80",
              "25106.40",
              "24708.80",
              "25008.80",
              "25216.00",
              "24928.00",
              "25209.20",
              "25194.40",
              "25301.20",
              "25031.20",
              "24951.20",
              "24823.20",
              "24730.40",
              "24646.40",
              "24578.40",
              "24602.40",
              "24700.40",
              "24652.40",
              "24728.40"
            ],
            type: 'line',
            color: '#0e96f6',
            areaStyle: {
              color: '#2e5897',
            },
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            name: '今日负荷'
          }
        ]
      };
      this.$refs.vchartLine.setData(nv)

    },
    destroyed () {
      this.realTimeValueStore.commit("removeKeys",this.nowLoadDeviceFromname)
      removeTask("refreshUnitDayInfo")
    },
    computed: {
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },

      nowUnit () {
        var nowunit=this.$store.unitStore.getters.getNowUnit
        findDemand({'unitId': nowunit.id}).then(res => {
          this.newdayMaxNeed=res.data.nowDayDemand
          this.newmonthMaxNeed=res.data.nowMonthDemand
          if(res.code!=200) {
            this.findDemand_fn()
          }
        })
        return nowunit
      },
      loadCapacity () {
        //总负荷容量,负荷设备是负荷配置中配置的当前单位的负荷设备，然后通过他们绑定的台账来查询额定容量属性
        var count=0
        for(var i=0,len=this.loadDeviceList.length;i<len;i++) {
          var item=this.loadDeviceList[i]
          var info=this.deviceNoToArchivesInfo[item.deviceno]
          if(!isempty(info)&&!isempty(info.next)) {
            var target=info.next.find(it => it.propertyCode=="Capacity")
            let target2=info.next.find(it => it.propertyCode=="edrl")
            if(!isempty(target)&&!isempty(target.value)) {
              try {
                count+=parseFloat(target.value)
              } catch(e) {}
            }
            if(!isempty(target2)&&!isempty(target2.value)) {
              try {
                count+=parseFloat(target2.value)
              } catch(e) {}
            }
          }
        }
        return parseInt(count)
      },
      nowReadDeviceTree () {
        //当前单位可查看虚拟设备树
        return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
      },
      roomCount () {
        //配电房数量，由当前单位下所有类型为配电房的虚拟设备组的数量决定，配电房下的配电房也算配电房
        var list=treeToList(this.nowReadDeviceTree,'next',item => {
          return item.hasOwnProperty("next")
        })
        return list.filter(item => {
          return item.devicetype==2
        }).length
      },
      realLoad () {
        var list=this.nowLoadDeviceFromname
        var values=this.realTimeValueStore.getters.getValue(list)
        var count=0
        for(var i=0,len=values.length;i<len;i++) {
          if(values[i]!=undefined) {
            count+=parseFloat(values[i])
          }
        }
        //实时负荷
        return (Math.round(count*Math.pow(10,2)))/Math.pow(10,2)
      },
      realLoadRate () {
        if(this.loadCapacity!=0&&this.realLoad!=0) {
          return cutDigital(this.realLoad/this.loadCapacity*100)
        }
        return '0.00'
      },
      dayMaxRate () {
        var rate='0.00'
        try {
          rate=cutDigital(this.dayMaxLoad/this.loadCapacity*100)
          if(isempty(rate)||isNaN(rate)) {
            return '0.00'
          }
        } catch(e) {}
        return rate
      },
      monthMaxRate () {
        var rate='0.00'
        try {
          rate=cutDigital(this.monthMaxLoad/this.loadCapacity*100)
          if(isempty(rate)||isNaN(rate)) {
            return '0.00'
          }
        } catch(e) {}
        return rate
      },
      xList () {
        var list=[]
        for(var h=0,len=24;h<len;h++) {
          for(var m=0,lenm=60;m<lenm;m+=5) {
            list.push((h<10? '0':'')+h+':'+(m<10? '0':'')+m)
          }
        }
        return list
      },

    },
    watch: {

      nowLoadDeviceFromname (nv,ov) {
        if(!isempty(ov)) {
          //移除旧变量
          this.realTimeValueStore.commit("removeKeys",ov)
        }
        if(!isempty(nv)) {
          this.realTimeValueStore.commit("addKeys",nv)
        }
      },
      nowUnit (nv,ov) {
        this.getLoadValue(nv.id)
        this.findDemand_fn()
      },
    },
    methods: {
      flagFned () {
        console.log(1111111111);
        this.flaged=!this.flaged;
      },
      findDemand_fn () {
        findDemand({'unitId': this.nowUnit.id}).then(res => {
          this.newdayMaxNeed=res.data.nowDayDemand
          this.newmonthMaxNeed=res.data.nowMonthDemand
          if(res.code!=200) {
            this.findDemand_fn()
          }
        })
      },
      getLoadValue (unitId) {
        //获取单位相关的数据
        if(isempty(unitId)) {
          return
        }
        //获取变压器负荷设备列表
        this.$api.deviceApi.getDeviceListByDeviceType(unitId,'load',respon => {
          this.loadDeviceList=respon
          this.$api.archivesApi.getArchivesInfoByVirtualDeviceNos(respon.map(item => item.deviceno).join(','),tree => {
            this.deviceNoToArchivesInfo=tree
          })
        })
        //查询月最大需量
        this.$api.powerApi.getMonthMaxLoadDemand(unitId,new Date().getTime(),respon => {
          this.monthMaxNeed=isempty(respon)? '--':respon
        })
        //查询日最大需量
        this.$api.powerApi.getDayMaxLoadDemand(unitId,new Date().getTime(),respon => {
          this.dayMaxNeed=isempty(respon)? '--':respon
        })
        //查询日最大负荷
        this.$api.powerApi.getDayMaxLoad(unitId,new Date().getTime(),respon => {
          this.dayMaxLoad=isempty(respon)? '--':respon
        })
        //查询月最大负荷
        this.$api.powerApi.getMonthMaxLoad(unitId,new Date().getTime(),respon => {
          this.monthMaxLoad=isempty(respon)? '--':respon
        })
        //获取实时负荷
        this.$api.powerApi.getLoadFromnameByUnitId(unitId,respon => {
          this.nowLoadDeviceFromname=isempty(respon)? '--':respon
        })


      },
    }
  }
</script>

<style scoped>
  .bodyBorder2 {
    display: flex;
    height: calc(100% - 36px)
  }

  .dialoged {
    background: url("../../../assets/kanban/Group132.png") no-repeat;
    width: 307px;
    height: 177px;
    position: absolute;
    top: -136px;
    right: 109px;
  }

  .dialoged .dialoged_box .dialoged_tit {
    font-weight: bold;
  }

  .dialoged .dialoged_box .p {
    color: #DF9B36;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;
    padding-left: 8px;

  }

  .dialoged .dialoged_box {
    font-family: Microsoft YaHei;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    box-sizing: border-box;
    padding: 6px 0 13px 12px;
  }

  .smallWindow {
    width: calc(50% - 6px);
  }

  .topLeftTitleContent2 {
    position: relative;
    border: 4px solid #19485C;
    box-sizing: border-box;
  }

  .topLeftTitleContent2 .titled .img {
    padding: 6px 4px;
    padding-top: 4px;
  }

  .topLeftTitleContent2 .titled {
    /* background-image: linear-gradient(to top, #31A9DD, #AAE5FF); */
    color: #fff;
    -webkit-background-clip: text;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid;
    border-image: linear-gradient(-90deg, #31A9DD00 0%, #32AADD 100%) 1;

  }

  .active {
    transform: scale(1.5) translateY(38px);
  }

  .iconed {
    display: flex;
    align-items: center;
    margin-left: auto;
    float: right;
  }

  @import url("../../../components/css/usePowerUnit.css");

  .divbody>>>.default-chart {
    height: 100%;
    width: 100%;
  }

  .dayInfoBody {
    height: 240px;
  }

  .dayInfoContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: calc(100% - 31px);
  }

  .divbody {
    width: 100%;
    display: flex;
  }

  /* .divbody2 {

    padding: 10px 0;
    height: calc(100% - 20px);
    padding-top: 32px;
  } */

  .column {
    width: 160px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    margin-left: calc((100% - 480px)/4);
  }

  .info {
    font-size: 16px;
    font-family: "黑体";
  }

  .circle {
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    .dayInfoContent {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
    }

    .divbody {
      width: 100%;
      height: 250px;
    }
  }
</style>